import { isDefined } from './is-defined.util';

export const isOnClient =
  (typeof process === 'undefined' || !isDefined(process)) &&
  isDefined(globalThis);
